import ViewPanel from './ViewPanel/index.js';
import DataPanel from './DataPanel/index.js';
import DataInter_Menu from './DataInter_Menu/index.js';
import DataScrollList_DataPageList from './DataScrollList_DataPageList/index.js';
import DetailPanel from './DetailPanel/index.js';
import DataForm_SettingFormData from './DataForm_SettingFormData/index.js'
export default { 
  Name: "Columns",
  Title: "栏目",
  Value: [
    { Theme: "", Category: "面板", Comps: "面板", Name: "ViewPanel", Component: ViewPanel },
    { Theme: "", Category: "数量统计", Comps: "数量统计", Name: "DataPanel", Component: DataPanel },
    { Theme: "单行菜单", Category: "按钮", Comps: "单行菜单", Name: "DataInter_Menu", Component: DataInter_Menu },
    { Theme: "数据分页列表", Category: "数据列表", Comps: "数据分页列表", Name: "DataScrollList_DataPageList", Component: DataScrollList_DataPageList },
    { Theme: "", Category: "视图面板", Comps: "视图面板", Name: "DetailPanel", Component: DetailPanel },
    { Theme: "配置表单", Category: "表单", Comps: "配置表单", Name: "DataForm_SettingFormData", Component: DataForm_SettingFormData }
  ]
}